import React, { FunctionComponent } from 'react';

import styles from './Icon.module.css';
import Adjust from '../../svgs/adjust.svg';
import Airplay from '../../svgs/airplay.svg';
import AlarmCheck from '../../svgs/alarmCheck.svg';
import AlarmClock from '../../svgs/alarmClock.svg';
import AlarmClockOff from '../../svgs/alarmClockOff.svg';
import AlertCircle from '../../svgs/alertCircle.svg';
import AlertOctagon from '../../svgs/alertOctagon.svg';
import AlertTriangle from '../../svgs/alertTriangle.svg';
import AlignCenter from '../../svgs/alignCenter.svg';
import AlignJustify from '../../svgs/alignJustify.svg';
import AlignLeft from '../../svgs/alignLeft.svg';
import AlignRight from '../../svgs/alignRight.svg';
import AngleDoubleDown from '../../svgs/angleDoubleDown.svg';
import AngleDoubleLeft from '../../svgs/angleDoubleLeft.svg';
import AngleDoubleRight from '../../svgs/angleDoubleRight.svg';
import AngleDoubleUp from '../../svgs/angleDoubleUp.svg';
import AngleDown from '../../svgs/angleDown.svg';
import AngleLeft from '../../svgs/angleLeft.svg';
import AngleRight from '../../svgs/angleRight.svg';
import AngleUp from '../../svgs/angleUp.svg';
import Angry from '../../svgs/angry.svg';
import Annoyed from '../../svgs/annoyed.svg';
import ArchiveFilled from '../../svgs/archiveFilled.svg';
import ArchiveOutline from '../../svgs/archiveOutline.svg';
import ArrowBigDown from '../../svgs/arrowBigDown.svg';
import ArrowBigDownDash from '../../svgs/arrowBigDownDash.svg';
import ArrowBigLeft from '../../svgs/arrowBigLeft.svg';
import ArrowBigLeftDash from '../../svgs/arrowBigLeftDash.svg';
import ArrowBigRight from '../../svgs/arrowBigRight.svg';
import ArrowBigRightDash from '../../svgs/arrowBigRightDash.svg';
import ArrowBigUp from '../../svgs/arrowBigUp.svg';
import ArrowBigUpDash from '../../svgs/arrowBigUpDash.svg';
import ArrowDown from '../../svgs/arrowDown.svg';
import ArrowDownAxAsc from '../../svgs/arrowDownAxAsc.svg';
import ArrowDownCircle from '../../svgs/arrowDownCircle.svg';
import ArrowDownFromLine from '../../svgs/arrowDownFromLine.svg';
import ArrowDownLeft from '../../svgs/arrowDownLeft.svg';
import ArrowDownLeftFromCircle from '../../svgs/arrowDownLeftFromCircle.svg';
import ArrowDownLeftSquare from '../../svgs/arrowDownLeftSquare.svg';
import ArrowDownNarrowWide from '../../svgs/arrowDownNarrowWide.svg';
import ArrowDownNumAsc from '../../svgs/arrowDownNumAsc.svg';
import ArrowDownRight from '../../svgs/arrowDownRight.svg';
import ArrowDownRightFromCircle from '../../svgs/arrowDownRightFromCircle.svg';
import ArrowDownRightSquare from '../../svgs/arrowDownRightSquare.svg';
import ArrowDownSquare from '../../svgs/arrowDownSquare.svg';
import ArrowDownToDot from '../../svgs/arrowDownToDot.svg';
import ArrowDownUp from '../../svgs/arrowDownUp.svg';
import ArrowDownWideNarrow from '../../svgs/arrowDownWideNarrow.svg';
import ArrowLeft from '../../svgs/arrowLeft.svg';
import ArrowLeftCircle from '../../svgs/arrowLeftCircle.svg';
import ArrowLeftFromLine from '../../svgs/arrowLeftFromLine.svg';
import ArrowLeftSquare from '../../svgs/arrowLeftSquare.svg';
import ArrowLeftToLine from '../../svgs/arrowLeftToLine.svg';
import ArrowRight from '../../svgs/arrowRight.svg';
import ArrowRightCircle from '../../svgs/arrowRightCircle.svg';
import ArrowRightFromLine from '../../svgs/arrowRightFromLine.svg';
import ArrowRightLeft from '../../svgs/arrowRightLeft.svg';
import ArrowRightSquare from '../../svgs/arrowRightSquare.svg';
import ArrowRightToLine from '../../svgs/arrowRightToLine.svg';
import ArrowsUpFromLine from '../../svgs/arrowsUpFromLine.svg';
import ArrowUp from '../../svgs/arrowUp.svg';
import ArrowUpAzDesc from '../../svgs/arrowUpAzDesc.svg';
import ArrowUpCircle from '../../svgs/arrowUpCircle.svg';
import ArrowUpDown from '../../svgs/arrowUpDown.svg';
import ArrowUpFromDot from '../../svgs/arrowUpFromDot.svg';
import ArrowUpLeft from '../../svgs/arrowUpLeft.svg';
import ArrowUpLeftFromCircle from '../../svgs/arrowUpLeftFromCircle.svg';
import ArrowUpLeftSquare from '../../svgs/arrowUpLeftSquare.svg';
import ArrowUpNarrowWide from '../../svgs/arrowUpNarrowWide.svg';
import ArrowUpNumDesc from '../../svgs/arrowUpNumDesc.svg';
import ArrowUpRight from '../../svgs/arrowUpRight.svg';
import ArrowUpRightFromCircle from '../../svgs/arrowUpRightFromCircle.svg';
import ArrowUpRightSquare from '../../svgs/arrowUpRightSquare.svg';
import ArrowUpSquare from '../../svgs/arrowUpSquare.svg';
import ArrowUpToLine from '../../svgs/arrowUpToLine.svg';
import ArrowUpWideNarrow from '../../svgs/arrowUpWideNarrow.svg';
import BadgeAlert from '../../svgs/badgeAlert.svg';
import BadgeCheck from '../../svgs/badgeCheck.svg';
import BalanceFilled from '../../svgs/balanceFilled.svg';
import BalanceOutline from '../../svgs/balanceOutline.svg';
import BandaidFilled from '../../svgs/bandaidFilled.svg';
import BandaidOutline from '../../svgs/bandaidOutline.svg';
import BanFilled from '../../svgs/banFilled.svg';
import BanOutline from '../../svgs/banOutline.svg';
import BarChart from '../../svgs/barChart.svg';
import BarChartAxis from '../../svgs/barChartAxis.svg';
import BarChartAxisUptrend from '../../svgs/barChartAxisUptrend.svg';
import BarChartBig from '../../svgs/barChartBig.svg';
import BarChartHorizontal from '../../svgs/barChartHorizontal.svg';
import BarChartHorizontalBig from '../../svgs/barChartHorizontalBig.svg';
import BarChartUptrend from '../../svgs/barChartUptrend.svg';
import BasketFilled from '../../svgs/basketFilled.svg';
import BasketOutline from '../../svgs/basketOutline.svg';
import BatteryFull from '../../svgs/batteryFull.svg';
import BatteryLow from '../../svgs/batteryLow.svg';
import BatteryMedium from '../../svgs/batteryMedium.svg';
import Beach from '../../svgs/beach.svg';
import BellDot from '../../svgs/bellDot.svg';
import BellFilled from '../../svgs/bellFilled.svg';
import BellMinus from '../../svgs/bellMinus.svg';
import BellOff from '../../svgs/bellOff.svg';
import BellOutline from '../../svgs/bellOutline.svg';
import BellPlus from '../../svgs/bellPlus.svg';
import BellRing from '../../svgs/bellRing.svg';
import BloodPressureFilled from '../../svgs/bloodPressureFilled.svg';
import BloodPressureOutline from '../../svgs/bloodPressureOutline.svg';
import Bluetooth from '../../svgs/bluetooth.svg';
import BluetoothOff from '../../svgs/bluetoothOff.svg';
import BluetoothSearching from '../../svgs/bluetoothSearching.svg';
import Bold from '../../svgs/bold.svg';
import Book from '../../svgs/book.svg';
import BookCopy from '../../svgs/bookCopy.svg';
import BookDown from '../../svgs/bookDown.svg';
import BookKey from '../../svgs/bookKey.svg';
import BookLock from '../../svgs/bookLock.svg';
import BookMarked from '../../svgs/bookMarked.svg';
import BookmarkFilled from '../../svgs/bookmarkFilled.svg';
import BookmarkMinus from '../../svgs/bookmarkMinus.svg';
import BookmarkOutline from '../../svgs/bookmarkOutline.svg';
import BookmarkPlus from '../../svgs/bookmarkPlus.svg';
import BookMinus from '../../svgs/bookMinus.svg';
import BookOpen from '../../svgs/bookOpen.svg';
import BookPlus from '../../svgs/bookPlus.svg';
import BookTemplate from '../../svgs/bookTemplate.svg';
import BookUp from '../../svgs/bookUp.svg';
import BookUpDouble from '../../svgs/bookUpDouble.svg';
import BookX from '../../svgs/bookX.svg';
import BoxFilled from '../../svgs/boxFilled.svg';
import BoxOutline from '../../svgs/boxOutline.svg';
import Braille from '../../svgs/braille.svg';
import BricksFilled from '../../svgs/bricksFilled.svg';
import BricksOutline from '../../svgs/bricksOutline.svg';
import Bridge from '../../svgs/bridge.svg';
import Briefcase from '../../svgs/briefcase.svg';
import Building from '../../svgs/building.svg';
import Building2 from '../../svgs/building2.svg';
import BusFront from '../../svgs/busFront.svg';
import BusSide from '../../svgs/busSide.svg';
import Calculator from '../../svgs/calculator.svg';
import Calendar from '../../svgs/calendar.svg';
import CalendarCheck from '../../svgs/calendarCheck.svg';
import CalendarCheckInside from '../../svgs/calendarCheckInside.svg';
import CalendarClock from '../../svgs/calendarClock.svg';
import CalendarFilled from '../../svgs/calendarFilled.svg';
import CalendarHeart from '../../svgs/calendarHeart.svg';
import CalendarMinus from '../../svgs/calendarMinus.svg';
import CalendarOff from '../../svgs/calendarOff.svg';
import CalendarOutline from '../../svgs/calendarOutline.svg';
import CalendarPlus from '../../svgs/calendarPlus.svg';
import CalendarRange from '../../svgs/calendarRange.svg';
import CalendarSearch from '../../svgs/calendarSearch.svg';
import CalendarX from '../../svgs/calendarX.svg';
import CalendarXInside from '../../svgs/calendarXInside.svg';
import CameraFilled from '../../svgs/cameraFilled.svg';
import CameraOff from '../../svgs/cameraOff.svg';
import CameraOutline from '../../svgs/cameraOutline.svg';
import CaretDown from '../../svgs/caretDown.svg';
import CaretLeft from '../../svgs/caretLeft.svg';
import CaretRight from '../../svgs/caretRight.svg';
import CaretUp from '../../svgs/caretUp.svg';
import ChatFilled from '../../svgs/chatFilled.svg';
import ChatOutline from '../../svgs/chatOutline.svg';
import CheckCheck from '../../svgs/checkCheck.svg';
import CheckCircle from '../../svgs/checkCircle.svg';
import CheckCircleFilled from '../../svgs/checkCircleFilled.svg';
import CheckCircleOutline from '../../svgs/checkCircleOutline.svg';
import CheckDefault from '../../svgs/checkDefault.svg';
import CheckSquare from '../../svgs/checkSquare.svg';
import ChevronDownCircle from '../../svgs/chevronDownCircle.svg';
import ChevronDownSquare from '../../svgs/chevronDownSquare.svg';
import ChevronFirst from '../../svgs/chevronFirst.svg';
import ChevronLast from '../../svgs/chevronLast.svg';
import ChevronLeftCircle from '../../svgs/chevronLeftCircle.svg';
import ChevronLeftSquare from '../../svgs/chevronLeftSquare.svg';
import ChevronRightCircle from '../../svgs/chevronRightCircle.svg';
import ChevronRightSquare from '../../svgs/chevronRightSquare.svg';
import ChevronsDownUp from '../../svgs/chevronsDownUp.svg';
import ChevronsLeftRight from '../../svgs/chevronsLeftRight.svg';
import ChevronsRightLeft from '../../svgs/chevronsRightLeft.svg';
import ChevronUpCircle from '../../svgs/chevronUpCircle.svg';
import ChevronUpSquare from '../../svgs/chevronUpSquare.svg';
import CircleCrossFilled from '../../svgs/circleCrossFilled.svg';
import CircleCrossOutline from '../../svgs/circleCrossOutline.svg';
import CircleDollarSign from '../../svgs/circleDollarSign.svg';
import CircleEllipsis from '../../svgs/circleEllipsis.svg';
import CircleEmpty from '../../svgs/circleEmpty.svg';
import CircleError from '../../svgs/circleError.svg';
import CircleInProgress from '../../svgs/circleInProgress.svg';
import CircleStop from '../../svgs/circleStop.svg';
import ClearFormat from '../../svgs/clearFormat.svg';
import Clip from '../../svgs/clip.svg';
import Clipboard from '../../svgs/clipboard.svg';
import ClipboardCheck from '../../svgs/clipboardCheck.svg';
import ClipboardCopy from '../../svgs/clipboardCopy.svg';
import ClipboardEdit from '../../svgs/clipboardEdit.svg';
import ClipboardList from '../../svgs/clipboardList.svg';
import ClipboardPaste from '../../svgs/clipboardPaste.svg';
import ClipboardSignature from '../../svgs/clipboardSignature.svg';
import ClipboardType from '../../svgs/clipboardType.svg';
import ClipboardX from '../../svgs/clipboardX.svg';
import Clock from '../../svgs/clock.svg';
import Clock1 from '../../svgs/clock1.svg';
import Clock10 from '../../svgs/clock10.svg';
import Clock11 from '../../svgs/clock11.svg';
import Clock12 from '../../svgs/clock12.svg';
import Clock2 from '../../svgs/clock2.svg';
import Clock3 from '../../svgs/clock3.svg';
import Clock4 from '../../svgs/clock4.svg';
import Clock6 from '../../svgs/clock6.svg';
import Clock7 from '../../svgs/clock7.svg';
import Clock8 from '../../svgs/clock8.svg';
import Clock9 from '../../svgs/clock9.svg';
import ClockFilled from '../../svgs/clockFilled.svg';
import ClockOutline from '../../svgs/clockOutline.svg';
import Cloud from '../../svgs/cloud.svg';
import CloudCog from '../../svgs/cloudCog.svg';
import CloudDrizzle from '../../svgs/cloudDrizzle.svg';
import CloudFilled from '../../svgs/cloudFilled.svg';
import CloudFog from '../../svgs/cloudFog.svg';
import CloudHail from '../../svgs/cloudHail.svg';
import CloudLightning from '../../svgs/cloudLightning.svg';
import CloudMoon from '../../svgs/cloudMoon.svg';
import CloudMoonRain from '../../svgs/cloudMoonRain.svg';
import CloudOff from '../../svgs/cloudOff.svg';
import CloudOutline from '../../svgs/cloudOutline.svg';
import CloudRain from '../../svgs/cloudRain.svg';
import CloudRainWind from '../../svgs/cloudRainWind.svg';
import CloudSnow from '../../svgs/cloudSnow.svg';
import CloudSun from '../../svgs/cloudSun.svg';
import CloudSunRain from '../../svgs/cloudSunRain.svg';
import Cloudy from '../../svgs/cloudy.svg';
import Code from '../../svgs/code.svg';
import ConciergeBell from '../../svgs/conciergeBell.svg';
import Contrast from '../../svgs/contrast.svg';
import ContrastActive from '../../svgs/contrastActive.svg';
import Cookie from '../../svgs/cookie.svg';
import CopyCheck from '../../svgs/copyCheck.svg';
import CopyFilled from '../../svgs/copyFilled.svg';
import CopyLeft from '../../svgs/copyLeft.svg';
import CopyMinus from '../../svgs/copyMinus.svg';
import CopyOutline from '../../svgs/copyOutline.svg';
import CopyPlus from '../../svgs/copyPlus.svg';
import CopyRight from '../../svgs/copyRight.svg';
import CopySlash from '../../svgs/copySlash.svg';
import CopyX from '../../svgs/copyX.svg';
import CreditCardFilled from '../../svgs/creditCardFilled.svg';
import CreditCardOutline from '../../svgs/creditCardOutline.svg';
import CrossFilled from '../../svgs/crossFilled.svg';
import CrossOutline from '../../svgs/crossOutline.svg';
import Database from '../../svgs/database.svg';
import DatabaseBackup from '../../svgs/databaseBackup.svg';
import DataFilled from '../../svgs/dataFilled.svg';
import DataOutline from '../../svgs/dataOutline.svg';
import Deaf from '../../svgs/deaf.svg';
import DecreaseFont from '../../svgs/decreaseFont.svg';
import Delete from '../../svgs/delete.svg';
import DesktopFilled from '../../svgs/desktopFilled.svg';
import DesktopOutline from '../../svgs/desktopOutline.svg';
import DogLeashed from '../../svgs/dogLeashed.svg';
import DollarSign from '../../svgs/dollarSign.svg';
import Dots from '../../svgs/dots.svg';
import Download from '../../svgs/download.svg';
import DownloadCloud from '../../svgs/downloadCloud.svg';
import DragDrop from '../../svgs/dragDrop.svg';
import Dribbble from '../../svgs/dribbble.svg';
import DropFilled from '../../svgs/dropFilled.svg';
import Droplet from '../../svgs/droplet.svg';
import Droplets from '../../svgs/droplets.svg';
import DropOutline from '../../svgs/dropOutline.svg';
import DumbbellFilled from '../../svgs/dumbbellFilled.svg';
import DumbbellOutline from '../../svgs/dumbbellOutline.svg';
import EmailFilled from '../../svgs/emailFilled.svg';
import EmailOutline from '../../svgs/emailOutline.svg';
import Euro from '../../svgs/euro.svg';
import Exchange from '../../svgs/exchange.svg';
import ExclamationDefault from '../../svgs/exclamationDefault.svg';
import ExclamationTriangleFilled from '../../svgs/exclamationTriangleFilled.svg';
import ExclamationTriangleOutline from '../../svgs/exclamationTriangleOutline.svg';
import Expand from '../../svgs/expand.svg';
import ExternalLink from '../../svgs/externalLink.svg';
import EyeFilled from '../../svgs/eyeFilled.svg';
import EyeHiddenFilled from '../../svgs/eyeHiddenFilled.svg';
import EyeHiddenOutline from '../../svgs/eyeHiddenOutline.svg';
import EyeOutline from '../../svgs/eyeOutline.svg';
import Facebook from '../../svgs/facebook.svg';
import FaucetFilled from '../../svgs/faucetFilled.svg';
import FaucetOutline from '../../svgs/faucetOutline.svg';
import FileArchive from '../../svgs/fileArchive.svg';
import FileAudio from '../../svgs/fileAudio.svg';
import FileAxis3d from '../../svgs/fileAxis3d.svg';
import FileBadge from '../../svgs/fileBadge.svg';
import FileBadgeInside from '../../svgs/fileBadgeInside.svg';
import FileBarChart from '../../svgs/fileBarChart.svg';
import FileBarChartUpTrend from '../../svgs/fileBarChartUpTrend.svg';
import FileBox from '../../svgs/fileBox.svg';
import FileCheck from '../../svgs/fileCheck.svg';
import FileCheckInside from '../../svgs/fileCheckInside.svg';
import FileClock from '../../svgs/fileClock.svg';
import FileCode from '../../svgs/fileCode.svg';
import FileCodeInside from '../../svgs/fileCodeInside.svg';
import FileCog from '../../svgs/fileCog.svg';
import FileCogInside from '../../svgs/fileCogInside.svg';
import FileDiff from '../../svgs/fileDiff.svg';
import FileDigit from '../../svgs/fileDigit.svg';
import FileDown from '../../svgs/fileDown.svg';
import FileEdit from '../../svgs/fileEdit.svg';
import FileEmptyFilled from '../../svgs/fileEmptyFilled.svg';
import FileEmptyOutline from '../../svgs/fileEmptyOutline.svg';
import FileHeart from '../../svgs/fileHeart.svg';
import FileImage from '../../svgs/fileImage.svg';
import FileInput from '../../svgs/fileInput.svg';
import FileJson from '../../svgs/fileJson.svg';
import FileJsonInside from '../../svgs/fileJsonInside.svg';
import FileKey from '../../svgs/fileKey.svg';
import FileKeyInside from '../../svgs/fileKeyInside.svg';
import FileLineChart from '../../svgs/fileLineChart.svg';
import FileLock from '../../svgs/fileLock.svg';
import FileLockInside from '../../svgs/fileLockInside.svg';
import FileMinus from '../../svgs/fileMinus.svg';
import FileMinusInside from '../../svgs/fileMinusInside.svg';
import FileOutput from '../../svgs/fileOutput.svg';
import FilePieChart from '../../svgs/filePieChart.svg';
import FilePlus from '../../svgs/filePlus.svg';
import FilePlusInside from '../../svgs/filePlusInside.svg';
import FileQuestion from '../../svgs/fileQuestion.svg';
import Files from '../../svgs/files.svg';
import FileScan from '../../svgs/fileScan.svg';
import FileSearch from '../../svgs/fileSearch.svg';
import FileSignature from '../../svgs/fileSignature.svg';
import FileStack from '../../svgs/fileStack.svg';
import FileSymlink from '../../svgs/fileSymlink.svg';
import FileTerminal from '../../svgs/fileTerminal.svg';
import FileText from '../../svgs/fileText.svg';
import FileType from '../../svgs/fileType.svg';
import FileTypeInside from '../../svgs/fileTypeInside.svg';
import FileUp from '../../svgs/fileUp.svg';
import FileVideo from '../../svgs/fileVideo.svg';
import FileVideoInside from '../../svgs/fileVideoInside.svg';
import FileVisualizationFilled from '../../svgs/fileVisualizationFilled.svg';
import FileVisualizationOutline from '../../svgs/fileVisualizationOutline.svg';
import FileVolume from '../../svgs/fileVolume.svg';
import FileVolumeInside from '../../svgs/fileVolumeInside.svg';
import FileWarning from '../../svgs/fileWarning.svg';
import FileWithItemsFilled from '../../svgs/fileWithItemsFilled.svg';
import FileWithItemsOutline from '../../svgs/fileWithItemsOutline.svg';
import FileX from '../../svgs/fileX.svg';
import FileXInside from '../../svgs/fileXInside.svg';
import FilterFilled from '../../svgs/filterFilled.svg';
import FilterOutline from '../../svgs/filterOutline.svg';
import FilterX from '../../svgs/filterX.svg';
import Flag from '../../svgs/flag.svg';
import Flashlight from '../../svgs/flashlight.svg';
import FlashlightOff from '../../svgs/flashlightOff.svg';
import Folder from '../../svgs/folder.svg';
import FolderArchive from '../../svgs/folderArchive.svg';
import FolderCheck from '../../svgs/folderCheck.svg';
import FolderClock from '../../svgs/folderClock.svg';
import FolderClosed from '../../svgs/folderClosed.svg';
import FolderCog from '../../svgs/folderCog.svg';
import FolderCogInside from '../../svgs/folderCogInside.svg';
import FolderDot from '../../svgs/folderDot.svg';
import FolderDown from '../../svgs/folderDown.svg';
import FolderEdit from '../../svgs/folderEdit.svg';
import FolderFilled from '../../svgs/folderFilled.svg';
import FolderGit from '../../svgs/folderGit.svg';
import FolderGitInside from '../../svgs/folderGitInside.svg';
import FolderHeart from '../../svgs/folderHeart.svg';
import FolderInput from '../../svgs/folderInput.svg';
import FolderKanban from '../../svgs/folderKanban.svg';
import FolderKey from '../../svgs/folderKey.svg';
import FolderLock from '../../svgs/folderLock.svg';
import FolderMinus from '../../svgs/folderMinus.svg';
import FolderOpen from '../../svgs/folderOpen.svg';
import FolderOutput from '../../svgs/folderOutput.svg';
import FolderPlus from '../../svgs/folderPlus.svg';
import FolderRoot from '../../svgs/folderRoot.svg';
import Folders from '../../svgs/folders.svg';
import FolderSearch from '../../svgs/folderSearch.svg';
import FolderSearchInside from '../../svgs/folderSearchInside.svg';
import FolderSymlink from '../../svgs/folderSymlink.svg';
import FolderSync from '../../svgs/folderSync.svg';
import FolderTree from '../../svgs/folderTree.svg';
import FolderUp from '../../svgs/folderUp.svg';
import FolderX from '../../svgs/folderX.svg';
import FoldHorizontal from '../../svgs/foldHorizontal.svg';
import FoldVertical from '../../svgs/foldVertical.svg';
import Frown from '../../svgs/frown.svg';
import FullScreen from '../../svgs/fullScreen.svg';
import FullScreenOff from '../../svgs/fullScreenOff.svg';
import Gauge from '../../svgs/gauge.svg';
import GaugeCircle from '../../svgs/gaugeCircle.svg';
import GearFilled from '../../svgs/gearFilled.svg';
import GearOutline from '../../svgs/gearOutline.svg';
import Gift from '../../svgs/gift.svg';
import Globe from '../../svgs/globe.svg';
import Globe2 from '../../svgs/globe2.svg';
import Glucometer from '../../svgs/glucometer.svg';
import GripHorizontal from '../../svgs/gripHorizontal.svg';
import HamburgerMenu from '../../svgs/hamburgerMenu.svg';
import Hand from '../../svgs/hand.svg';
import HandMetal from '../../svgs/handMetal.svg';
import Headphones from '../../svgs/headphones.svg';
import HeartCrack from '../../svgs/heartCrack.svg';
import HeartFilled from '../../svgs/heartFilled.svg';
import HeartHandshake from '../../svgs/heartHandshake.svg';
import HeartOff from '../../svgs/heartOff.svg';
import HeartOutline from '../../svgs/heartOutline.svg';
import HeartPulse from '../../svgs/heartPulse.svg';
import HeartRateFilled from '../../svgs/heartRateFilled.svg';
import HeartRateOutline from '../../svgs/heartRateOutline.svg';
import HelpingHand from '../../svgs/helpingHand.svg';
import Highlighter from '../../svgs/highlighter.svg';
import History from '../../svgs/history.svg';
import HomeFilled from '../../svgs/homeFilled.svg';
import HomeOutline from '../../svgs/homeOutline.svg';
import Hospital from '../../svgs/hospital.svg';
import Hourglass from '../../svgs/hourglass.svg';
import HouseFilled from '../../svgs/houseFilled.svg';
import HouseOutline from '../../svgs/houseOutline.svg';
import ImageFilled from '../../svgs/imageFilled.svg';
import ImageMinus from '../../svgs/imageMinus.svg';
import ImageOff from '../../svgs/imageOff.svg';
import ImageOutline from '../../svgs/imageOutline.svg';
import ImagePlus from '../../svgs/imagePlus.svg';
import ImcFilled from '../../svgs/imcFilled.svg';
import Import from '../../svgs/import.svg';
import Inbox from '../../svgs/inbox.svg';
import IncreaseFont from '../../svgs/increaseFont.svg';
import InfoCircleFilled from '../../svgs/infoCircleFilled.svg';
import InfoCircleOutline from '../../svgs/infoCircleOutline.svg';
import InfoDefault from '../../svgs/infoDefault.svg';
import Instagram from '../../svgs/instagram.svg';
import Italic from '../../svgs/italic.svg';
import JapaneseYen from '../../svgs/japaneseYen.svg';
import KeyFilled from '../../svgs/keyFilled.svg';
import KeyOutline from '../../svgs/keyOutline.svg';
import Laugh from '../../svgs/laugh.svg';
import Layout from '../../svgs/layout.svg';
import LayoutDashboard from '../../svgs/layoutDashboard.svg';
import LayoutGrid from '../../svgs/layoutGrid.svg';
import LayoutList from '../../svgs/layoutList.svg';
import LayoutPanelLeft from '../../svgs/layoutPanelLeft.svg';
import LayoutPanelTop from '../../svgs/layoutPanelTop.svg';
import LayoutTemplate from '../../svgs/layoutTemplate.svg';
import LightbulbFilled from '../../svgs/lightbulbFilled.svg';
import LightbulbOff from '../../svgs/lightbulbOff.svg';
import LightbulbOutline from '../../svgs/lightbulbOutline.svg';
import LightningBolt from '../../svgs/lightningBolt.svg';
import Link from '../../svgs/link.svg';
import Linkedin from '../../svgs/linkedin.svg';
import LinkOff from '../../svgs/linkOff.svg';
import List from '../../svgs/list.svg';
import ListChecks from '../../svgs/listChecks.svg';
import ListFilter from '../../svgs/listFilter.svg';
import ListStart from '../../svgs/listStart.svg';
import Llp from '../../svgs/llp.svg';
import Loader from '../../svgs/loader.svg';
import Loading from '../../svgs/loading.svg';
import LockCloseFilled from '../../svgs/lockCloseFilled.svg';
import LockCloseOutline from '../../svgs/lockCloseOutline.svg';
import LockOpenFilled from '../../svgs/lockOpenFilled.svg';
import LockOpenOutline from '../../svgs/lockOpenOutline.svg';
import LogIn from '../../svgs/logIn.svg';
import Lungs from '../../svgs/lungs.svg';
import Mailbox from '../../svgs/mailbox.svg';
import MailCheck from '../../svgs/mailCheck.svg';
import MailMinus from '../../svgs/mailMinus.svg';
import MailOpen from '../../svgs/mailOpen.svg';
import MailPlus from '../../svgs/mailPlus.svg';
import MailQuestion from '../../svgs/mailQuestion.svg';
import Mails from '../../svgs/mails.svg';
import MailSearch from '../../svgs/mailSearch.svg';
import MailWarning from '../../svgs/mailWarning.svg';
import MailX from '../../svgs/mailX.svg';
import MapFilled from '../../svgs/mapFilled.svg';
import MapMarkerFilled from '../../svgs/mapMarkerFilled.svg';
import MapMarkerOutline from '../../svgs/mapMarkerOutline.svg';
import MapOutline from '../../svgs/mapOutline.svg';
import MapPinOff from '../../svgs/mapPinOff.svg';
import Maximize from '../../svgs/maximize.svg';
import MedicineBottleFilled from '../../svgs/medicineBottleFilled.svg';
import MedicineBottleOutline from '../../svgs/medicineBottleOutline.svg';
import Megaphone from '../../svgs/megaphone.svg';
import MegaphoneOff from '../../svgs/megaphoneOff.svg';
import Meh from '../../svgs/meh.svg';
import MenuSquare from '../../svgs/menuSquare.svg';
import MessageCircle from '../../svgs/messageCircle.svg';
import MessageSquare from '../../svgs/messageSquare.svg';
import MessageSquareDashed from '../../svgs/messageSquareDashed.svg';
import MessageSquarePlus from '../../svgs/messageSquarePlus.svg';
import MessagesSquare from '../../svgs/messagesSquare.svg';
import MicrophoneFilled from '../../svgs/microphoneFilled.svg';
import MicrophoneOutline from '../../svgs/microphoneOutline.svg';
import Minimize from '../../svgs/minimize.svg';
import Minus from '../../svgs/minus.svg';
import MinusCircle from '../../svgs/minusCircle.svg';
import MinusSquare from '../../svgs/minusSquare.svg';
import Module from '../../svgs/module.svg';
import MonitorCheck from '../../svgs/monitorCheck.svg';
import MonitorPlay from '../../svgs/monitorPlay.svg';
import MonitorSmartphone from '../../svgs/monitorSmartphone.svg';
import MoreHorizontal from '../../svgs/moreHorizontal.svg';
import Mouse from '../../svgs/mouse.svg';
import MousePointer from '../../svgs/mousePointer.svg';
import MousePointerClick from '../../svgs/mousePointerClick.svg';
import Move from '../../svgs/move.svg';
import MoveDiagonalL2R from '../../svgs/moveDiagonalL2R.svg';
import MoveDiagonalR2L from '../../svgs/moveDiagonalR2L.svg';
import MoveDown from '../../svgs/moveDown.svg';
import MoveDownLeft from '../../svgs/moveDownLeft.svg';
import MoveDownRight from '../../svgs/moveDownRight.svg';
import MoveHorizontal from '../../svgs/moveHorizontal.svg';
import MoveLeft from '../../svgs/moveLeft.svg';
import MoveRight from '../../svgs/moveRight.svg';
import MoveUp from '../../svgs/moveUp.svg';
import MoveUpLeft from '../../svgs/moveUpLeft.svg';
import MoveUpRight from '../../svgs/moveUpRight.svg';
import MoveVertical from '../../svgs/moveVertical.svg';
import MugFilled from '../../svgs/mugFilled.svg';
import MugOutline from '../../svgs/mugOutline.svg';
import MultipleUsersFilled from '../../svgs/multipleUsersFilled.svg';
import MultipleUsersOutline from '../../svgs/multipleUsersOutline.svg';
import NeedleFilled from '../../svgs/needleFilled.svg';
import NeedleOutline from '../../svgs/needleOutline.svg';
import Nurse from '../../svgs/nurse.svg';
import NurseView from '../../svgs/nurseView.svg';
import O2Filled from '../../svgs/o2Filled.svg';
import OpenDoor from '../../svgs/openDoor.svg';
import PackageCheck from '../../svgs/packageCheck.svg';
import PackageOpen from '../../svgs/packageOpen.svg';
import PackageSearch from '../../svgs/packageSearch.svg';
import PartyPopper from '../../svgs/partyPopper.svg';
import Pause from '../../svgs/pause.svg';
import PauseCircle from '../../svgs/pauseCircle.svg';
import PauseFilled from '../../svgs/pauseFilled.svg';
import Pen from '../../svgs/pen.svg';
import PencilLine from '../../svgs/pencilLine.svg';
import PencilRuler from '../../svgs/pencilRuler.svg';
import PenFilled from '../../svgs/penFilled.svg';
import PenOutline from '../../svgs/penOutline.svg';
import PenSquare from '../../svgs/penSquare.svg';
import PenTool from '../../svgs/penTool.svg';
import PenToolFilled from '../../svgs/penToolFilled.svg';
import Percent from '../../svgs/percent.svg';
import PetFilled from '../../svgs/petFilled.svg';
import PetOutline from '../../svgs/petOutline.svg';
import PhoneCall from '../../svgs/phoneCall.svg';
import PhoneFilled from '../../svgs/phoneFilled.svg';
import PhoneForwarded from '../../svgs/phoneForwarded.svg';
import PhoneIncoming from '../../svgs/phoneIncoming.svg';
import PhoneMissed from '../../svgs/phoneMissed.svg';
import PhoneOff from '../../svgs/phoneOff.svg';
import PhoneOutgoing from '../../svgs/phoneOutgoing.svg';
import PhoneOutline from '../../svgs/phoneOutline.svg';
import PillFilled from '../../svgs/pillFilled.svg';
import PillOutline from '../../svgs/pillOutline.svg';
import Pin from '../../svgs/pin.svg';
import PinOff from '../../svgs/pinOff.svg';
import PipeFilled from '../../svgs/pipeFilled.svg';
import PipeOutline from '../../svgs/pipeOutline.svg';
import PlayCircle from '../../svgs/playCircle.svg';
import PlayFilled from '../../svgs/playFilled.svg';
import PlayOutline from '../../svgs/playOutline.svg';
import PlaySquare from '../../svgs/playSquare.svg';
import Plus from '../../svgs/plus.svg';
import PlusCircle from '../../svgs/plusCircle.svg';
import PlusSquare from '../../svgs/plusSquare.svg';
import Pointer from '../../svgs/pointer.svg';
import PollFilled from '../../svgs/pollFilled.svg';
import PollOutline from '../../svgs/pollOutline.svg';
import Pound from '../../svgs/pound.svg';
import PresentationFilled from '../../svgs/presentationFilled.svg';
import PresentationOutline from '../../svgs/presentationOutline.svg';
import PrinterFilled from '../../svgs/printerFilled.svg';
import PrinterOutline from '../../svgs/printerOutline.svg';
import QrCode from '../../svgs/qrCode.svg';
import QuestionMarkFilled from '../../svgs/questionMarkFilled.svg';
import QuestionMarkOutline from '../../svgs/questionMarkOutline.svg';
import Quote from '../../svgs/quote.svg';
import QuoteLeft from '../../svgs/quoteLeft.svg';
import QuoteRight from '../../svgs/quoteRight.svg';
import Redo from '../../svgs/redo.svg';
import RefreshCcw from '../../svgs/refreshCcw.svg';
import RefreshCcwDot from '../../svgs/refreshCcwDot.svg';
import RefreshCwOff from '../../svgs/refreshCwOff.svg';
import RoadFilled from '../../svgs/roadFilled.svg';
import RoadOutline from '../../svgs/roadOutline.svg';
import Rocket from '../../svgs/rocket.svg';
import RotateCcw from '../../svgs/rotateCcw.svg';
import RotateCw from '../../svgs/rotateCw.svg';
import RulerFilled from '../../svgs/rulerFilled.svg';
import RulerOutline from '../../svgs/rulerOutline.svg';
import Save from '../../svgs/save.svg';
import SaveAll from '../../svgs/saveAll.svg';
import SaveFilled from '../../svgs/saveFilled.svg';
import Scale from '../../svgs/scale.svg';
import Scale3d from '../../svgs/scale3d.svg';
import Scan from '../../svgs/scan.svg';
import ScanFace from '../../svgs/scanFace.svg';
import ScanLine from '../../svgs/scanLine.svg';
import ScrollText from '../../svgs/scrollText.svg';
import SearchCheck from '../../svgs/searchCheck.svg';
import SearchCode from '../../svgs/searchCode.svg';
import SearchSlash from '../../svgs/searchSlash.svg';
import SearchX from '../../svgs/searchX.svg';
import Send from '../../svgs/send.svg';
import SendHorizonal from '../../svgs/sendHorizonal.svg';
import Share from '../../svgs/share.svg';
import ShareFilled from '../../svgs/shareFilled.svg';
import ShareOutline from '../../svgs/shareOutline.svg';
import ShieldAlert from '../../svgs/shieldAlert.svg';
import ShieldCheck from '../../svgs/shieldCheck.svg';
import ShieldFilled from '../../svgs/shieldFilled.svg';
import ShieldOutline from '../../svgs/shieldOutline.svg';
import ShieldTickOutline from '../../svgs/shieldTickOutline.svg';
import Shirt from '../../svgs/shirt.svg';
import ShoppingBag from '../../svgs/shoppingBag.svg';
import ShoppingCart from '../../svgs/shoppingCart.svg';
import Shrink from '../../svgs/shrink.svg';
import Shuffle from '../../svgs/shuffle.svg';
import SignLanguage from '../../svgs/signLanguage.svg';
import SignOut from '../../svgs/signOut.svg';
import SkipBack from '../../svgs/skipBack.svg';
import SkipForward from '../../svgs/skipForward.svg';
import Slack from '../../svgs/slack.svg';
import Smartphone from '../../svgs/smartphone.svg';
import SmartphoneCharging from '../../svgs/smartphoneCharging.svg';
import SmartphoneNfc from '../../svgs/smartphoneNfc.svg';
import Smile from '../../svgs/smile.svg';
import SmilePlus from '../../svgs/smilePlus.svg';
import Sort from '../../svgs/sort.svg';
import Sparkle from '../../svgs/sparkle.svg';
import Sparkles from '../../svgs/sparkles.svg';
import SpellCheck from '../../svgs/spellCheck.svg';
import SpellCheckHighlight from '../../svgs/spellCheckHighlight.svg';
import Split from '../../svgs/split.svg';
import StarFilled from '../../svgs/starFilled.svg';
import StarHalf from '../../svgs/starHalf.svg';
import StarOff from '../../svgs/starOff.svg';
import StarOutline from '../../svgs/starOutline.svg';
import StethoscopeFilled from '../../svgs/stethoscopeFilled.svg';
import StethoscopeOutline from '../../svgs/stethoscopeOutline.svg';
import StopFilled from '../../svgs/stopFilled.svg';
import StopOutline from '../../svgs/stopOutline.svg';
import Strikethrough from '../../svgs/strikethrough.svg';
import SwitchCamera from '../../svgs/switchCamera.svg';
import Sync from '../../svgs/sync.svg';
import Tag from '../../svgs/tag.svg';
import Tags from '../../svgs/tags.svg';
import TextCursor from '../../svgs/textCursor.svg';
import TextCursorInput from '../../svgs/textCursorInput.svg';
import TextQuote from '../../svgs/textQuote.svg';
import TextSelect from '../../svgs/textSelect.svg';
import ThermometerFilled from '../../svgs/thermometerFilled.svg';
import ThermometerOutline from '../../svgs/thermometerOutline.svg';
import ThumbsDown from '../../svgs/thumbsDown.svg';
import ThumbsUp from '../../svgs/thumbsUp.svg';
import TimerFilled from '../../svgs/timerFilled.svg';
import TimerOff from '../../svgs/timerOff.svg';
import TimerOutline from '../../svgs/timerOutline.svg';
import TimerReset from '../../svgs/timerReset.svg';
import TimesDefault from '../../svgs/timesDefault.svg';
import TimesFilled from '../../svgs/timesFilled.svg';
import TimesOutline from '../../svgs/timesOutline.svg';
import Trash from '../../svgs/trash.svg';
import TrashFilled from '../../svgs/trashFilled.svg';
import TrashOutline from '../../svgs/trashOutline.svg';
import TreeDeciduous from '../../svgs/treeDeciduous.svg';
import TreePine from '../../svgs/treePine.svg';
import Trees from '../../svgs/trees.svg';
import TrendingDown from '../../svgs/trendingDown.svg';
import TrendingUp from '../../svgs/trendingUp.svg';
import Twitter from '../../svgs/twitter.svg';
import Underline from '../../svgs/underline.svg';
import Undo from '../../svgs/undo.svg';
import UnfoldHorizontal from '../../svgs/unfoldHorizontal.svg';
import UnfoldVertical from '../../svgs/unfoldVertical.svg';
import UniversalAccess from '../../svgs/universalAccess.svg';
import Unlink from '../../svgs/unlink.svg';
import UnlinkAlt from '../../svgs/unlinkAlt.svg';
import Upload from '../../svgs/upload.svg';
import UploadCloud from '../../svgs/uploadCloud.svg';
import User from '../../svgs/user.svg';
import UserBan from '../../svgs/userBan.svg';
import UserCard from '../../svgs/userCard.svg';
import UserCheck from '../../svgs/userCheck.svg';
import UserCircle from '../../svgs/userCircle.svg';
import UserCog from '../../svgs/userCog.svg';
import UserFilled from '../../svgs/userFilled.svg';
import UserMinus from '../../svgs/userMinus.svg';
import UserPlus from '../../svgs/userPlus.svg';
import UserReturn from '../../svgs/userReturn.svg';
import UserSquare from '../../svgs/userSquare.svg';
import UserTimes from '../../svgs/userTimes.svg';
import VideoFilled from '../../svgs/videoFilled.svg';
import VideoOutline from '../../svgs/videoOutline.svg';
import Voicemail from '../../svgs/voicemail.svg';
import VolumeMax from '../../svgs/volumeMax.svg';
import VolumeMaxFilled from '../../svgs/volumeMaxFilled.svg';
import VolumeMute from '../../svgs/volumeMute.svg';
import VolumeMuteFilled from '../../svgs/volumeMuteFilled.svg';
import VolumeNone from '../../svgs/volumeNone.svg';
import VolumeOn from '../../svgs/volumeOn.svg';
import Walker from '../../svgs/walker.svg';
import Wallet from '../../svgs/wallet.svg';
import WalletCards from '../../svgs/walletCards.svg';
import Wheelchair from '../../svgs/wheelchair.svg';
import Wifi from '../../svgs/wifi.svg';
import WifiOff from '../../svgs/wifiOff.svg';
import WrapText from '../../svgs/wrapText.svg';
import Wrench from '../../svgs/wrench.svg';
import XOctagon from '../../svgs/xOctagon.svg';
import Xp from '../../svgs/xp.svg';
import XSquare from '../../svgs/xSquare.svg';
import Youtube from '../../svgs/youtube.svg';
import Zap from '../../svgs/zap.svg';
import ZapOff from '../../svgs/zapOff.svg';
import ZoomMinusFilled from '../../svgs/zoomMinusFilled.svg';
import ZoomMinusOutline from '../../svgs/zoomMinusOutline.svg';
import ZoomOutline from '../../svgs/zoomOutline.svg';
import ZoomPlusFilled from '../../svgs/zoomPlusFilled.svg';
import ZoomPlusOutline from '../../svgs/zoomPlusOutline.svg';

export const Icons = [
  'adjust',
  'airplay',
  'alarmCheck',
  'alarmClock',
  'alarmClockOff',
  'alertCircle',
  'alertOctagon',
  'alertTriangle',
  'alignCenter',
  'alignJustify',
  'alignLeft',
  'alignRight',
  'angleDoubleDown',
  'angleDoubleLeft',
  'angleDoubleRight',
  'angleDoubleUp',
  'angleDown',
  'angleLeft',
  'angleRight',
  'angleUp',
  'angry',
  'annoyed',
  'archiveFilled',
  'archiveOutline',
  'arrowBigDown',
  'arrowBigDownDash',
  'arrowBigLeft',
  'arrowBigLeftDash',
  'arrowBigRight',
  'arrowBigRightDash',
  'arrowBigUp',
  'arrowBigUpDash',
  'arrowDown',
  'arrowDownAxAsc',
  'arrowDownCircle',
  'arrowDownFromLine',
  'arrowDownLeft',
  'arrowDownLeftFromCircle',
  'arrowDownLeftSquare',
  'arrowDownNarrowWide',
  'arrowDownNumAsc',
  'arrowDownRight',
  'arrowDownRightFromCircle',
  'arrowDownRightSquare',
  'arrowDownSquare',
  'arrowDownToDot',
  'arrowDownUp',
  'arrowDownWideNarrow',
  'arrowLeft',
  'arrowLeftCircle',
  'arrowLeftFromLine',
  'arrowLeftSquare',
  'arrowLeftToLine',
  'arrowRight',
  'arrowRightCircle',
  'arrowRightFromLine',
  'arrowRightLeft',
  'arrowRightSquare',
  'arrowRightToLine',
  'arrowUp',
  'arrowUpAzDesc',
  'arrowUpCircle',
  'arrowUpDown',
  'arrowUpFromDot',
  'arrowUpLeft',
  'arrowUpLeftFromCircle',
  'arrowUpLeftSquare',
  'arrowUpNarrowWide',
  'arrowUpNumDesc',
  'arrowUpRight',
  'arrowUpRightFromCircle',
  'arrowUpRightSquare',
  'arrowUpSquare',
  'arrowUpToLine',
  'arrowUpWideNarrow',
  'arrowsUpFromLine',
  'badgeAlert',
  'badgeCheck',
  'balanceFilled',
  'balanceOutline',
  'banFilled',
  'banOutline',
  'bandaidFilled',
  'bandaidOutline',
  'barChart',
  'barChartAxis',
  'barChartAxisUptrend',
  'barChartBig',
  'barChartHorizontal',
  'barChartHorizontalBig',
  'barChartUptrend',
  'basketFilled',
  'basketOutline',
  'batteryFull',
  'batteryLow',
  'batteryMedium',
  'beach',
  'bellDot',
  'bellFilled',
  'bellMinus',
  'bellOff',
  'bellOutline',
  'bellPlus',
  'bellRing',
  'bloodPressureFilled',
  'bloodPressureOutline',
  'bluetooth',
  'bluetoothOff',
  'bluetoothSearching',
  'bold',
  'book',
  'bookCopy',
  'bookDown',
  'bookKey',
  'bookLock',
  'bookMarked',
  'bookMinus',
  'bookOpen',
  'bookPlus',
  'bookTemplate',
  'bookUp',
  'bookUpDouble',
  'bookX',
  'bookmarkFilled',
  'bookmarkMinus',
  'bookmarkOutline',
  'bookmarkPlus',
  'boxFilled',
  'boxOutline',
  'braille',
  'bricksFilled',
  'bricksOutline',
  'bridge',
  'briefcase',
  'building',
  'building2',
  'busFront',
  'busSide',
  'calculator',
  'calendar',
  'calendarCheck',
  'calendarCheckInside',
  'calendarClock',
  'calendarFilled',
  'calendarHeart',
  'calendarMinus',
  'calendarOff',
  'calendarOutline',
  'calendarPlus',
  'calendarRange',
  'calendarSearch',
  'calendarX',
  'calendarXInside',
  'cameraFilled',
  'cameraOff',
  'cameraOutline',
  'caretDown',
  'caretLeft',
  'caretRight',
  'caretUp',
  'chatFilled',
  'chatOutline',
  'checkCheck',
  'checkCircle',
  'checkCircleFilled',
  'checkCircleOutline',
  'checkDefault',
  'checkSquare',
  'chevronDownCircle',
  'chevronDownSquare',
  'chevronFirst',
  'chevronLast',
  'chevronLeftCircle',
  'chevronLeftSquare',
  'chevronRightCircle',
  'chevronRightSquare',
  'chevronUpCircle',
  'chevronUpSquare',
  'chevronsDownUp',
  'chevronsLeftRight',
  'chevronsRightLeft',
  'circleCrossFilled',
  'circleCrossOutline',
  'circleDollarSign',
  'circleEllipsis',
  'circleEmpty',
  'circleError',
  'circleInProgress',
  'circleStop',
  'clearFormat',
  'clip',
  'clipboard',
  'clipboardCheck',
  'clipboardCopy',
  'clipboardEdit',
  'clipboardList',
  'clipboardPaste',
  'clipboardSignature',
  'clipboardType',
  'clipboardX',
  'clock',
  'clock1',
  'clock10',
  'clock11',
  'clock12',
  'clock2',
  'clock3',
  'clock4',
  'clock6',
  'clock7',
  'clock8',
  'clock9',
  'clockFilled',
  'clockOutline',
  'cloud',
  'cloudCog',
  'cloudDrizzle',
  'cloudFilled',
  'cloudFog',
  'cloudHail',
  'cloudLightning',
  'cloudMoon',
  'cloudMoonRain',
  'cloudOff',
  'cloudOutline',
  'cloudRain',
  'cloudRainWind',
  'cloudSnow',
  'cloudSun',
  'cloudSunRain',
  'cloudy',
  'code',
  'conciergeBell',
  'contrast',
  'contrastActive',
  'cookie',
  'copyCheck',
  'copyFilled',
  'copyLeft',
  'copyMinus',
  'copyOutline',
  'copyPlus',
  'copyRight',
  'copySlash',
  'copyX',
  'creditCardFilled',
  'creditCardOutline',
  'crossFilled',
  'crossOutline',
  'dataFilled',
  'dataOutline',
  'database',
  'databaseBackup',
  'deaf',
  'decreaseFont',
  'delete',
  'desktopFilled',
  'desktopOutline',
  'dogLeashed',
  'dollarSign',
  'dots',
  'download',
  'downloadCloud',
  'dragDrop',
  'dribbble',
  'dropFilled',
  'dropOutline',
  'droplet',
  'droplets',
  'dumbbellFilled',
  'dumbbellOutline',
  'emailFilled',
  'emailOutline',
  'euro',
  'exchange',
  'exclamationDefault',
  'exclamationTriangleFilled',
  'exclamationTriangleOutline',
  'expand',
  'externalLink',
  'eyeFilled',
  'eyeHiddenFilled',
  'eyeHiddenOutline',
  'eyeOutline',
  'facebook',
  'faucetFilled',
  'faucetOutline',
  'fileArchive',
  'fileAudio',
  'fileAxis3d',
  'fileBadge',
  'fileBadgeInside',
  'fileBarChart',
  'fileBarChartUpTrend',
  'fileBox',
  'fileCheck',
  'fileCheckInside',
  'fileClock',
  'fileCode',
  'fileCodeInside',
  'fileCog',
  'fileCogInside',
  'fileDiff',
  'fileDigit',
  'fileDown',
  'fileEdit',
  'fileEmptyFilled',
  'fileEmptyOutline',
  'fileHeart',
  'fileImage',
  'fileInput',
  'fileJson',
  'fileJsonInside',
  'fileKey',
  'fileKeyInside',
  'fileLineChart',
  'fileLock',
  'fileLockInside',
  'fileMinus',
  'fileMinusInside',
  'fileOutput',
  'filePieChart',
  'filePlus',
  'filePlusInside',
  'fileQuestion',
  'fileScan',
  'fileSearch',
  'fileSignature',
  'fileStack',
  'fileSymlink',
  'fileTerminal',
  'fileText',
  'fileType',
  'fileTypeInside',
  'fileUp',
  'fileVideo',
  'fileVideoInside',
  'fileVisualizationFilled',
  'fileVisualizationOutline',
  'fileVolume',
  'fileVolumeInside',
  'fileWarning',
  'fileWithItemsFilled',
  'fileWithItemsOutline',
  'fileX',
  'fileXInside',
  'files',
  'filterFilled',
  'filterOutline',
  'filterX',
  'flag',
  'flashlight',
  'flashlightOff',
  'foldHorizontal',
  'foldVertical',
  'folder',
  'folderArchive',
  'folderCheck',
  'folderClock',
  'folderClosed',
  'folderCog',
  'folderCogInside',
  'folderDot',
  'folderDown',
  'folderEdit',
  'folderFilled',
  'folderGit',
  'folderGitInside',
  'folderHeart',
  'folderInput',
  'folderKanban',
  'folderKey',
  'folderLock',
  'folderMinus',
  'folderOpen',
  'folderOutput',
  'folderPlus',
  'folderRoot',
  'folderSearch',
  'folderSearchInside',
  'folderSymlink',
  'folderSync',
  'folderTree',
  'folderUp',
  'folderX',
  'folders',
  'frown',
  'fullScreen',
  'fullScreenOff',
  'gauge',
  'gaugeCircle',
  'gearFilled',
  'gearOutline',
  'gift',
  'globe',
  'globe2',
  'glucometer',
  'gripHorizontal',
  'hamburgerMenu',
  'hand',
  'handMetal',
  'headphones',
  'heartCrack',
  'heartFilled',
  'heartHandshake',
  'heartOff',
  'heartOutline',
  'heartPulse',
  'heartRateFilled',
  'heartRateOutline',
  'helpingHand',
  'highlighter',
  'history',
  'homeFilled',
  'homeOutline',
  'hospital',
  'hourglass',
  'houseFilled',
  'houseOutline',
  'imageFilled',
  'imageMinus',
  'imageOff',
  'imageOutline',
  'imagePlus',
  'imcFilled',
  'import',
  'inbox',
  'increaseFont',
  'infoCircleFilled',
  'infoCircleOutline',
  'infoDefault',
  'instagram',
  'italic',
  'japaneseYen',
  'keyFilled',
  'keyOutline',
  'laugh',
  'layout',
  'layoutDashboard',
  'layoutGrid',
  'layoutList',
  'layoutPanelLeft',
  'layoutPanelTop',
  'layoutTemplate',
  'lightbulbFilled',
  'lightbulbOff',
  'lightbulbOutline',
  'lightningBolt',
  'link',
  'linkOff',
  'linkedin',
  'list',
  'listChecks',
  'listFilter',
  'listStart',
  'llp',
  'loader',
  'loading',
  'lockCloseFilled',
  'lockCloseOutline',
  'lockOpenFilled',
  'lockOpenOutline',
  'logIn',
  'lungs',
  'mailCheck',
  'mailMinus',
  'mailOpen',
  'mailPlus',
  'mailQuestion',
  'mailSearch',
  'mailWarning',
  'mailX',
  'mailbox',
  'mails',
  'mapFilled',
  'mapMarkerFilled',
  'mapMarkerOutline',
  'mapOutline',
  'mapPinOff',
  'maximize',
  'medicineBottleFilled',
  'medicineBottleOutline',
  'megaphone',
  'megaphoneOff',
  'meh',
  'menuSquare',
  'messageCircle',
  'messageSquare',
  'messageSquareDashed',
  'messageSquarePlus',
  'messagesSquare',
  'microphoneFilled',
  'microphoneOutline',
  'minimize',
  'minus',
  'minusCircle',
  'minusSquare',
  'module',
  'monitorCheck',
  'monitorPlay',
  'monitorSmartphone',
  'moreHorizontal',
  'mouse',
  'mousePointer',
  'mousePointerClick',
  'move',
  'moveDiagonalL2R',
  'moveDiagonalR2L',
  'moveDown',
  'moveDownLeft',
  'moveDownRight',
  'moveHorizontal',
  'moveLeft',
  'moveRight',
  'moveUp',
  'moveUpLeft',
  'moveUpRight',
  'moveVertical',
  'mugFilled',
  'mugOutline',
  'multipleUsersFilled',
  'multipleUsersOutline',
  'needleFilled',
  'needleOutline',
  'nurse',
  'nurseView',
  'o2Filled',
  'openDoor',
  'packageCheck',
  'packageOpen',
  'packageSearch',
  'partyPopper',
  'pause',
  'pauseCircle',
  'pauseFilled',
  'pen',
  'penFilled',
  'penOutline',
  'penSquare',
  'penTool',
  'penToolFilled',
  'pencilLine',
  'pencilRuler',
  'percent',
  'petFilled',
  'petOutline',
  'phoneCall',
  'phoneFilled',
  'phoneForwarded',
  'phoneIncoming',
  'phoneMissed',
  'phoneOff',
  'phoneOutgoing',
  'phoneOutline',
  'pillFilled',
  'pillOutline',
  'pin',
  'pinOff',
  'pipeFilled',
  'pipeOutline',
  'playCircle',
  'playFilled',
  'playOutline',
  'playSquare',
  'plus',
  'plusCircle',
  'plusSquare',
  'pointer',
  'pollFilled',
  'pollOutline',
  'pound',
  'presentationFilled',
  'presentationOutline',
  'printerFilled',
  'printerOutline',
  'qrCode',
  'questionMarkFilled',
  'questionMarkOutline',
  'quote',
  'quoteLeft',
  'quoteRight',
  'redo',
  'refreshCcw',
  'refreshCcwDot',
  'refreshCwOff',
  'roadFilled',
  'roadOutline',
  'rocket',
  'rotateCcw',
  'rotateCw',
  'rulerFilled',
  'rulerOutline',
  'save',
  'saveAll',
  'saveFilled',
  'scale',
  'scale3d',
  'scan',
  'scanFace',
  'scanLine',
  'scrollText',
  'searchCheck',
  'searchCode',
  'searchSlash',
  'searchX',
  'send',
  'sendHorizonal',
  'share',
  'shareFilled',
  'shareOutline',
  'shieldAlert',
  'shieldCheck',
  'shieldFilled',
  'shieldOutline',
  'shieldTickOutline',
  'shirt',
  'shoppingBag',
  'shoppingCart',
  'shrink',
  'shuffle',
  'signLanguage',
  'signOut',
  'skipBack',
  'skipForward',
  'slack',
  'smartphone',
  'smartphoneCharging',
  'smartphoneNfc',
  'smile',
  'smilePlus',
  'sort',
  'sparkle',
  'sparkles',
  'spellCheck',
  'spellCheckHighlight',
  'split',
  'starFilled',
  'starHalf',
  'starOff',
  'starOutline',
  'stethoscopeFilled',
  'stethoscopeOutline',
  'stopFilled',
  'stopOutline',
  'strikethrough',
  'switchCamera',
  'sync',
  'tag',
  'tags',
  'textCursor',
  'textCursorInput',
  'textQuote',
  'textSelect',
  'thermometerFilled',
  'thermometerOutline',
  'thumbsDown',
  'thumbsUp',
  'timerFilled',
  'timerOff',
  'timerOutline',
  'timerReset',
  'timesDefault',
  'timesFilled',
  'timesOutline',
  'trash',
  'trashFilled',
  'trashOutline',
  'treeDeciduous',
  'treePine',
  'trees',
  'trendingDown',
  'trendingUp',
  'twitter',
  'underline',
  'undo',
  'unfoldHorizontal',
  'unfoldVertical',
  'universalAccess',
  'unlink',
  'unlinkAlt',
  'upload',
  'uploadCloud',
  'user',
  'userBan',
  'userCard',
  'userCheck',
  'userCircle',
  'userCog',
  'userFilled',
  'userMinus',
  'userPlus',
  'userReturn',
  'userSquare',
  'userTimes',
  'videoFilled',
  'videoOutline',
  'voicemail',
  'volumeMax',
  'volumeMaxFilled',
  'volumeMute',
  'volumeMuteFilled',
  'volumeNone',
  'volumeOn',
  'walker',
  'wallet',
  'walletCards',
  'wheelchair',
  'wifi',
  'wifiOff',
  'wrapText',
  'wrench',
  'xOctagon',
  'xSquare',
  'xp',
  'youtube',
  'zap',
  'zapOff',
  'zoomMinusFilled',
  'zoomMinusOutline',
  'zoomOutline',
  'zoomPlusFilled',
  'zoomPlusOutline',
] as const;
export type IconNames = (typeof Icons)[number];

type IconType = React.SVGProps<SVGElement> & {
  icon: IconNames;
};

function getIconSvg(name: IconNames) {
  switch (name) {
    case 'adjust':
      return Adjust;
    case 'airplay':
      return Airplay;
    case 'alarmCheck':
      return AlarmCheck;
    case 'alarmClock':
      return AlarmClock;
    case 'alarmClockOff':
      return AlarmClockOff;
    case 'alertCircle':
      return AlertCircle;
    case 'alertOctagon':
      return AlertOctagon;
    case 'alertTriangle':
      return AlertTriangle;
    case 'alignCenter':
      return AlignCenter;
    case 'alignJustify':
      return AlignJustify;
    case 'alignLeft':
      return AlignLeft;
    case 'alignRight':
      return AlignRight;
    case 'angleDoubleDown':
      return AngleDoubleDown;
    case 'angleDoubleLeft':
      return AngleDoubleLeft;
    case 'angleDoubleRight':
      return AngleDoubleRight;
    case 'angleDoubleUp':
      return AngleDoubleUp;
    case 'angleDown':
      return AngleDown;
    case 'angleLeft':
      return AngleLeft;
    case 'angleRight':
      return AngleRight;
    case 'angleUp':
      return AngleUp;
    case 'angry':
      return Angry;
    case 'annoyed':
      return Annoyed;
    case 'archiveFilled':
      return ArchiveFilled;
    case 'archiveOutline':
      return ArchiveOutline;
    case 'arrowBigDown':
      return ArrowBigDown;
    case 'arrowBigDownDash':
      return ArrowBigDownDash;
    case 'arrowBigLeft':
      return ArrowBigLeft;
    case 'arrowBigLeftDash':
      return ArrowBigLeftDash;
    case 'arrowBigRight':
      return ArrowBigRight;
    case 'arrowBigRightDash':
      return ArrowBigRightDash;
    case 'arrowBigUp':
      return ArrowBigUp;
    case 'arrowBigUpDash':
      return ArrowBigUpDash;
    case 'arrowDown':
      return ArrowDown;
    case 'arrowDownAxAsc':
      return ArrowDownAxAsc;
    case 'arrowDownCircle':
      return ArrowDownCircle;
    case 'arrowDownFromLine':
      return ArrowDownFromLine;
    case 'arrowDownLeft':
      return ArrowDownLeft;
    case 'arrowDownLeftFromCircle':
      return ArrowDownLeftFromCircle;
    case 'arrowDownLeftSquare':
      return ArrowDownLeftSquare;
    case 'arrowDownNarrowWide':
      return ArrowDownNarrowWide;
    case 'arrowDownNumAsc':
      return ArrowDownNumAsc;
    case 'arrowDownRight':
      return ArrowDownRight;
    case 'arrowDownRightFromCircle':
      return ArrowDownRightFromCircle;
    case 'arrowDownRightSquare':
      return ArrowDownRightSquare;
    case 'arrowDownSquare':
      return ArrowDownSquare;
    case 'arrowDownToDot':
      return ArrowDownToDot;
    case 'arrowDownUp':
      return ArrowDownUp;
    case 'arrowDownWideNarrow':
      return ArrowDownWideNarrow;
    case 'arrowLeft':
      return ArrowLeft;
    case 'arrowLeftCircle':
      return ArrowLeftCircle;
    case 'arrowLeftFromLine':
      return ArrowLeftFromLine;
    case 'arrowLeftSquare':
      return ArrowLeftSquare;
    case 'arrowLeftToLine':
      return ArrowLeftToLine;
    case 'arrowRight':
      return ArrowRight;
    case 'arrowRightCircle':
      return ArrowRightCircle;
    case 'arrowRightFromLine':
      return ArrowRightFromLine;
    case 'arrowRightLeft':
      return ArrowRightLeft;
    case 'arrowRightSquare':
      return ArrowRightSquare;
    case 'arrowRightToLine':
      return ArrowRightToLine;
    case 'arrowUp':
      return ArrowUp;
    case 'arrowUpAzDesc':
      return ArrowUpAzDesc;
    case 'arrowUpCircle':
      return ArrowUpCircle;
    case 'arrowUpDown':
      return ArrowUpDown;
    case 'arrowUpFromDot':
      return ArrowUpFromDot;
    case 'arrowUpLeft':
      return ArrowUpLeft;
    case 'arrowUpLeftFromCircle':
      return ArrowUpLeftFromCircle;
    case 'arrowUpLeftSquare':
      return ArrowUpLeftSquare;
    case 'arrowUpNarrowWide':
      return ArrowUpNarrowWide;
    case 'arrowUpNumDesc':
      return ArrowUpNumDesc;
    case 'arrowUpRight':
      return ArrowUpRight;
    case 'arrowUpRightFromCircle':
      return ArrowUpRightFromCircle;
    case 'arrowUpRightSquare':
      return ArrowUpRightSquare;
    case 'arrowUpSquare':
      return ArrowUpSquare;
    case 'arrowUpToLine':
      return ArrowUpToLine;
    case 'arrowUpWideNarrow':
      return ArrowUpWideNarrow;
    case 'arrowsUpFromLine':
      return ArrowsUpFromLine;
    case 'badgeAlert':
      return BadgeAlert;
    case 'badgeCheck':
      return BadgeCheck;
    case 'balanceFilled':
      return BalanceFilled;
    case 'balanceOutline':
      return BalanceOutline;
    case 'banFilled':
      return BanFilled;
    case 'banOutline':
      return BanOutline;
    case 'bandaidFilled':
      return BandaidFilled;
    case 'bandaidOutline':
      return BandaidOutline;
    case 'barChart':
      return BarChart;
    case 'barChartAxis':
      return BarChartAxis;
    case 'barChartAxisUptrend':
      return BarChartAxisUptrend;
    case 'barChartBig':
      return BarChartBig;
    case 'barChartHorizontal':
      return BarChartHorizontal;
    case 'barChartHorizontalBig':
      return BarChartHorizontalBig;
    case 'barChartUptrend':
      return BarChartUptrend;
    case 'basketFilled':
      return BasketFilled;
    case 'basketOutline':
      return BasketOutline;
    case 'batteryFull':
      return BatteryFull;
    case 'batteryLow':
      return BatteryLow;
    case 'batteryMedium':
      return BatteryMedium;
    case 'beach':
      return Beach;
    case 'bellDot':
      return BellDot;
    case 'bellFilled':
      return BellFilled;
    case 'bellMinus':
      return BellMinus;
    case 'bellOff':
      return BellOff;
    case 'bellOutline':
      return BellOutline;
    case 'bellPlus':
      return BellPlus;
    case 'bellRing':
      return BellRing;
    case 'bloodPressureFilled':
      return BloodPressureFilled;
    case 'bloodPressureOutline':
      return BloodPressureOutline;
    case 'bluetooth':
      return Bluetooth;
    case 'bluetoothOff':
      return BluetoothOff;
    case 'bluetoothSearching':
      return BluetoothSearching;
    case 'bold':
      return Bold;
    case 'book':
      return Book;
    case 'bookCopy':
      return BookCopy;
    case 'bookDown':
      return BookDown;
    case 'bookKey':
      return BookKey;
    case 'bookLock':
      return BookLock;
    case 'bookMarked':
      return BookMarked;
    case 'bookMinus':
      return BookMinus;
    case 'bookOpen':
      return BookOpen;
    case 'bookPlus':
      return BookPlus;
    case 'bookTemplate':
      return BookTemplate;
    case 'bookUp':
      return BookUp;
    case 'bookUpDouble':
      return BookUpDouble;
    case 'bookX':
      return BookX;
    case 'bookmarkFilled':
      return BookmarkFilled;
    case 'bookmarkMinus':
      return BookmarkMinus;
    case 'bookmarkOutline':
      return BookmarkOutline;
    case 'bookmarkPlus':
      return BookmarkPlus;
    case 'boxFilled':
      return BoxFilled;
    case 'boxOutline':
      return BoxOutline;
    case 'braille':
      return Braille;
    case 'bricksFilled':
      return BricksFilled;
    case 'bricksOutline':
      return BricksOutline;
    case 'bridge':
      return Bridge;
    case 'briefcase':
      return Briefcase;
    case 'building':
      return Building;
    case 'building2':
      return Building2;
    case 'busFront':
      return BusFront;
    case 'busSide':
      return BusSide;
    case 'calculator':
      return Calculator;
    case 'calendar':
      return Calendar;
    case 'calendarCheck':
      return CalendarCheck;
    case 'calendarCheckInside':
      return CalendarCheckInside;
    case 'calendarClock':
      return CalendarClock;
    case 'calendarFilled':
      return CalendarFilled;
    case 'calendarHeart':
      return CalendarHeart;
    case 'calendarMinus':
      return CalendarMinus;
    case 'calendarOff':
      return CalendarOff;
    case 'calendarOutline':
      return CalendarOutline;
    case 'calendarPlus':
      return CalendarPlus;
    case 'calendarRange':
      return CalendarRange;
    case 'calendarSearch':
      return CalendarSearch;
    case 'calendarX':
      return CalendarX;
    case 'calendarXInside':
      return CalendarXInside;
    case 'cameraFilled':
      return CameraFilled;
    case 'cameraOff':
      return CameraOff;
    case 'cameraOutline':
      return CameraOutline;
    case 'caretDown':
      return CaretDown;
    case 'caretLeft':
      return CaretLeft;
    case 'caretRight':
      return CaretRight;
    case 'caretUp':
      return CaretUp;
    case 'chatFilled':
      return ChatFilled;
    case 'chatOutline':
      return ChatOutline;
    case 'checkCheck':
      return CheckCheck;
    case 'checkCircle':
      return CheckCircle;
    case 'checkCircleFilled':
      return CheckCircleFilled;
    case 'checkCircleOutline':
      return CheckCircleOutline;
    case 'checkDefault':
      return CheckDefault;
    case 'checkSquare':
      return CheckSquare;
    case 'chevronDownCircle':
      return ChevronDownCircle;
    case 'chevronDownSquare':
      return ChevronDownSquare;
    case 'chevronFirst':
      return ChevronFirst;
    case 'chevronLast':
      return ChevronLast;
    case 'chevronLeftCircle':
      return ChevronLeftCircle;
    case 'chevronLeftSquare':
      return ChevronLeftSquare;
    case 'chevronRightCircle':
      return ChevronRightCircle;
    case 'chevronRightSquare':
      return ChevronRightSquare;
    case 'chevronUpCircle':
      return ChevronUpCircle;
    case 'chevronUpSquare':
      return ChevronUpSquare;
    case 'chevronsDownUp':
      return ChevronsDownUp;
    case 'chevronsLeftRight':
      return ChevronsLeftRight;
    case 'chevronsRightLeft':
      return ChevronsRightLeft;
    case 'circleCrossFilled':
      return CircleCrossFilled;
    case 'circleCrossOutline':
      return CircleCrossOutline;
    case 'circleDollarSign':
      return CircleDollarSign;
    case 'circleEllipsis':
      return CircleEllipsis;
    case 'circleEmpty':
      return CircleEmpty;
    case 'circleError':
      return CircleError;
    case 'circleInProgress':
      return CircleInProgress;
    case 'circleStop':
      return CircleStop;
    case 'clearFormat':
      return ClearFormat;
    case 'clip':
      return Clip;
    case 'clipboard':
      return Clipboard;
    case 'clipboardCheck':
      return ClipboardCheck;
    case 'clipboardCopy':
      return ClipboardCopy;
    case 'clipboardEdit':
      return ClipboardEdit;
    case 'clipboardList':
      return ClipboardList;
    case 'clipboardPaste':
      return ClipboardPaste;
    case 'clipboardSignature':
      return ClipboardSignature;
    case 'clipboardType':
      return ClipboardType;
    case 'clipboardX':
      return ClipboardX;
    case 'clock':
      return Clock;
    case 'clock1':
      return Clock1;
    case 'clock10':
      return Clock10;
    case 'clock11':
      return Clock11;
    case 'clock12':
      return Clock12;
    case 'clock2':
      return Clock2;
    case 'clock3':
      return Clock3;
    case 'clock4':
      return Clock4;
    case 'clock6':
      return Clock6;
    case 'clock7':
      return Clock7;
    case 'clock8':
      return Clock8;
    case 'clock9':
      return Clock9;
    case 'clockFilled':
      return ClockFilled;
    case 'clockOutline':
      return ClockOutline;
    case 'cloud':
      return Cloud;
    case 'cloudCog':
      return CloudCog;
    case 'cloudDrizzle':
      return CloudDrizzle;
    case 'cloudFilled':
      return CloudFilled;
    case 'cloudFog':
      return CloudFog;
    case 'cloudHail':
      return CloudHail;
    case 'cloudLightning':
      return CloudLightning;
    case 'cloudMoon':
      return CloudMoon;
    case 'cloudMoonRain':
      return CloudMoonRain;
    case 'cloudOff':
      return CloudOff;
    case 'cloudOutline':
      return CloudOutline;
    case 'cloudRain':
      return CloudRain;
    case 'cloudRainWind':
      return CloudRainWind;
    case 'cloudSnow':
      return CloudSnow;
    case 'cloudSun':
      return CloudSun;
    case 'cloudSunRain':
      return CloudSunRain;
    case 'cloudy':
      return Cloudy;
    case 'code':
      return Code;
    case 'conciergeBell':
      return ConciergeBell;
    case 'contrast':
      return Contrast;
    case 'contrastActive':
      return ContrastActive;
    case 'cookie':
      return Cookie;
    case 'copyCheck':
      return CopyCheck;
    case 'copyFilled':
      return CopyFilled;
    case 'copyLeft':
      return CopyLeft;
    case 'copyMinus':
      return CopyMinus;
    case 'copyOutline':
      return CopyOutline;
    case 'copyPlus':
      return CopyPlus;
    case 'copyRight':
      return CopyRight;
    case 'copySlash':
      return CopySlash;
    case 'copyX':
      return CopyX;
    case 'creditCardFilled':
      return CreditCardFilled;
    case 'creditCardOutline':
      return CreditCardOutline;
    case 'crossFilled':
      return CrossFilled;
    case 'crossOutline':
      return CrossOutline;
    case 'dataFilled':
      return DataFilled;
    case 'dataOutline':
      return DataOutline;
    case 'database':
      return Database;
    case 'databaseBackup':
      return DatabaseBackup;
    case 'deaf':
      return Deaf;
    case 'decreaseFont':
      return DecreaseFont;
    case 'delete':
      return Delete;
    case 'desktopFilled':
      return DesktopFilled;
    case 'desktopOutline':
      return DesktopOutline;
    case 'dogLeashed':
      return DogLeashed;
    case 'dollarSign':
      return DollarSign;
    case 'dots':
      return Dots;
    case 'download':
      return Download;
    case 'downloadCloud':
      return DownloadCloud;
    case 'dragDrop':
      return DragDrop;
    case 'dribbble':
      return Dribbble;
    case 'dropFilled':
      return DropFilled;
    case 'dropOutline':
      return DropOutline;
    case 'droplet':
      return Droplet;
    case 'droplets':
      return Droplets;
    case 'dumbbellFilled':
      return DumbbellFilled;
    case 'dumbbellOutline':
      return DumbbellOutline;
    case 'emailFilled':
      return EmailFilled;
    case 'emailOutline':
      return EmailOutline;
    case 'euro':
      return Euro;
    case 'exchange':
      return Exchange;
    case 'exclamationDefault':
      return ExclamationDefault;
    case 'exclamationTriangleFilled':
      return ExclamationTriangleFilled;
    case 'exclamationTriangleOutline':
      return ExclamationTriangleOutline;
    case 'expand':
      return Expand;
    case 'externalLink':
      return ExternalLink;
    case 'eyeFilled':
      return EyeFilled;
    case 'eyeHiddenFilled':
      return EyeHiddenFilled;
    case 'eyeHiddenOutline':
      return EyeHiddenOutline;
    case 'eyeOutline':
      return EyeOutline;
    case 'facebook':
      return Facebook;
    case 'faucetFilled':
      return FaucetFilled;
    case 'faucetOutline':
      return FaucetOutline;
    case 'fileArchive':
      return FileArchive;
    case 'fileAudio':
      return FileAudio;
    case 'fileAxis3d':
      return FileAxis3d;
    case 'fileBadge':
      return FileBadge;
    case 'fileBadgeInside':
      return FileBadgeInside;
    case 'fileBarChart':
      return FileBarChart;
    case 'fileBarChartUpTrend':
      return FileBarChartUpTrend;
    case 'fileBox':
      return FileBox;
    case 'fileCheck':
      return FileCheck;
    case 'fileCheckInside':
      return FileCheckInside;
    case 'fileClock':
      return FileClock;
    case 'fileCode':
      return FileCode;
    case 'fileCodeInside':
      return FileCodeInside;
    case 'fileCog':
      return FileCog;
    case 'fileCogInside':
      return FileCogInside;
    case 'fileDiff':
      return FileDiff;
    case 'fileDigit':
      return FileDigit;
    case 'fileDown':
      return FileDown;
    case 'fileEdit':
      return FileEdit;
    case 'fileEmptyFilled':
      return FileEmptyFilled;
    case 'fileEmptyOutline':
      return FileEmptyOutline;
    case 'fileHeart':
      return FileHeart;
    case 'fileImage':
      return FileImage;
    case 'fileInput':
      return FileInput;
    case 'fileJson':
      return FileJson;
    case 'fileJsonInside':
      return FileJsonInside;
    case 'fileKey':
      return FileKey;
    case 'fileKeyInside':
      return FileKeyInside;
    case 'fileLineChart':
      return FileLineChart;
    case 'fileLock':
      return FileLock;
    case 'fileLockInside':
      return FileLockInside;
    case 'fileMinus':
      return FileMinus;
    case 'fileMinusInside':
      return FileMinusInside;
    case 'fileOutput':
      return FileOutput;
    case 'filePieChart':
      return FilePieChart;
    case 'filePlus':
      return FilePlus;
    case 'filePlusInside':
      return FilePlusInside;
    case 'fileQuestion':
      return FileQuestion;
    case 'fileScan':
      return FileScan;
    case 'fileSearch':
      return FileSearch;
    case 'fileSignature':
      return FileSignature;
    case 'fileStack':
      return FileStack;
    case 'fileSymlink':
      return FileSymlink;
    case 'fileTerminal':
      return FileTerminal;
    case 'fileText':
      return FileText;
    case 'fileType':
      return FileType;
    case 'fileTypeInside':
      return FileTypeInside;
    case 'fileUp':
      return FileUp;
    case 'fileVideo':
      return FileVideo;
    case 'fileVideoInside':
      return FileVideoInside;
    case 'fileVisualizationFilled':
      return FileVisualizationFilled;
    case 'fileVisualizationOutline':
      return FileVisualizationOutline;
    case 'fileVolume':
      return FileVolume;
    case 'fileVolumeInside':
      return FileVolumeInside;
    case 'fileWarning':
      return FileWarning;
    case 'fileWithItemsFilled':
      return FileWithItemsFilled;
    case 'fileWithItemsOutline':
      return FileWithItemsOutline;
    case 'fileX':
      return FileX;
    case 'fileXInside':
      return FileXInside;
    case 'files':
      return Files;
    case 'filterFilled':
      return FilterFilled;
    case 'filterOutline':
      return FilterOutline;
    case 'filterX':
      return FilterX;
    case 'flag':
      return Flag;
    case 'flashlight':
      return Flashlight;
    case 'flashlightOff':
      return FlashlightOff;
    case 'foldHorizontal':
      return FoldHorizontal;
    case 'foldVertical':
      return FoldVertical;
    case 'folder':
      return Folder;
    case 'folderArchive':
      return FolderArchive;
    case 'folderCheck':
      return FolderCheck;
    case 'folderClock':
      return FolderClock;
    case 'folderClosed':
      return FolderClosed;
    case 'folderCog':
      return FolderCog;
    case 'folderCogInside':
      return FolderCogInside;
    case 'folderDot':
      return FolderDot;
    case 'folderDown':
      return FolderDown;
    case 'folderEdit':
      return FolderEdit;
    case 'folderFilled':
      return FolderFilled;
    case 'folderGit':
      return FolderGit;
    case 'folderGitInside':
      return FolderGitInside;
    case 'folderHeart':
      return FolderHeart;
    case 'folderInput':
      return FolderInput;
    case 'folderKanban':
      return FolderKanban;
    case 'folderKey':
      return FolderKey;
    case 'folderLock':
      return FolderLock;
    case 'folderMinus':
      return FolderMinus;
    case 'folderOpen':
      return FolderOpen;
    case 'folderOutput':
      return FolderOutput;
    case 'folderPlus':
      return FolderPlus;
    case 'folderRoot':
      return FolderRoot;
    case 'folderSearch':
      return FolderSearch;
    case 'folderSearchInside':
      return FolderSearchInside;
    case 'folderSymlink':
      return FolderSymlink;
    case 'folderSync':
      return FolderSync;
    case 'folderTree':
      return FolderTree;
    case 'folderUp':
      return FolderUp;
    case 'folderX':
      return FolderX;
    case 'folders':
      return Folders;
    case 'frown':
      return Frown;
    case 'fullScreen':
      return FullScreen;
    case 'fullScreenOff':
      return FullScreenOff;
    case 'gauge':
      return Gauge;
    case 'gaugeCircle':
      return GaugeCircle;
    case 'gearFilled':
      return GearFilled;
    case 'gearOutline':
      return GearOutline;
    case 'gift':
      return Gift;
    case 'globe':
      return Globe;
    case 'globe2':
      return Globe2;
    case 'glucometer':
      return Glucometer;
    case 'gripHorizontal':
      return GripHorizontal;
    case 'hamburgerMenu':
      return HamburgerMenu;
    case 'hand':
      return Hand;
    case 'handMetal':
      return HandMetal;
    case 'headphones':
      return Headphones;
    case 'heartCrack':
      return HeartCrack;
    case 'heartFilled':
      return HeartFilled;
    case 'heartHandshake':
      return HeartHandshake;
    case 'heartOff':
      return HeartOff;
    case 'heartOutline':
      return HeartOutline;
    case 'heartPulse':
      return HeartPulse;
    case 'heartRateFilled':
      return HeartRateFilled;
    case 'heartRateOutline':
      return HeartRateOutline;
    case 'helpingHand':
      return HelpingHand;
    case 'highlighter':
      return Highlighter;
    case 'history':
      return History;
    case 'homeFilled':
      return HomeFilled;
    case 'homeOutline':
      return HomeOutline;
    case 'hospital':
      return Hospital;
    case 'hourglass':
      return Hourglass;
    case 'houseFilled':
      return HouseFilled;
    case 'houseOutline':
      return HouseOutline;
    case 'imageFilled':
      return ImageFilled;
    case 'imageMinus':
      return ImageMinus;
    case 'imageOff':
      return ImageOff;
    case 'imageOutline':
      return ImageOutline;
    case 'imagePlus':
      return ImagePlus;
    case 'imcFilled':
      return ImcFilled;
    case 'import':
      return Import;
    case 'inbox':
      return Inbox;
    case 'increaseFont':
      return IncreaseFont;
    case 'infoCircleFilled':
      return InfoCircleFilled;
    case 'infoCircleOutline':
      return InfoCircleOutline;
    case 'infoDefault':
      return InfoDefault;
    case 'instagram':
      return Instagram;
    case 'italic':
      return Italic;
    case 'japaneseYen':
      return JapaneseYen;
    case 'keyFilled':
      return KeyFilled;
    case 'keyOutline':
      return KeyOutline;
    case 'laugh':
      return Laugh;
    case 'layout':
      return Layout;
    case 'layoutDashboard':
      return LayoutDashboard;
    case 'layoutGrid':
      return LayoutGrid;
    case 'layoutList':
      return LayoutList;
    case 'layoutPanelLeft':
      return LayoutPanelLeft;
    case 'layoutPanelTop':
      return LayoutPanelTop;
    case 'layoutTemplate':
      return LayoutTemplate;
    case 'lightbulbFilled':
      return LightbulbFilled;
    case 'lightbulbOff':
      return LightbulbOff;
    case 'lightbulbOutline':
      return LightbulbOutline;
    case 'lightningBolt':
      return LightningBolt;
    case 'link':
      return Link;
    case 'linkOff':
      return LinkOff;
    case 'linkedin':
      return Linkedin;
    case 'list':
      return List;
    case 'listChecks':
      return ListChecks;
    case 'listFilter':
      return ListFilter;
    case 'listStart':
      return ListStart;
    case 'llp':
      return Llp;
    case 'loader':
      return Loader;
    case 'loading':
      return Loading;
    case 'lockCloseFilled':
      return LockCloseFilled;
    case 'lockCloseOutline':
      return LockCloseOutline;
    case 'lockOpenFilled':
      return LockOpenFilled;
    case 'lockOpenOutline':
      return LockOpenOutline;
    case 'logIn':
      return LogIn;
    case 'lungs':
      return Lungs;
    case 'mailCheck':
      return MailCheck;
    case 'mailMinus':
      return MailMinus;
    case 'mailOpen':
      return MailOpen;
    case 'mailPlus':
      return MailPlus;
    case 'mailQuestion':
      return MailQuestion;
    case 'mailSearch':
      return MailSearch;
    case 'mailWarning':
      return MailWarning;
    case 'mailX':
      return MailX;
    case 'mailbox':
      return Mailbox;
    case 'mails':
      return Mails;
    case 'mapFilled':
      return MapFilled;
    case 'mapMarkerFilled':
      return MapMarkerFilled;
    case 'mapMarkerOutline':
      return MapMarkerOutline;
    case 'mapOutline':
      return MapOutline;
    case 'mapPinOff':
      return MapPinOff;
    case 'maximize':
      return Maximize;
    case 'medicineBottleFilled':
      return MedicineBottleFilled;
    case 'medicineBottleOutline':
      return MedicineBottleOutline;
    case 'megaphone':
      return Megaphone;
    case 'megaphoneOff':
      return MegaphoneOff;
    case 'meh':
      return Meh;
    case 'menuSquare':
      return MenuSquare;
    case 'messageCircle':
      return MessageCircle;
    case 'messageSquare':
      return MessageSquare;
    case 'messageSquareDashed':
      return MessageSquareDashed;
    case 'messageSquarePlus':
      return MessageSquarePlus;
    case 'messagesSquare':
      return MessagesSquare;
    case 'microphoneFilled':
      return MicrophoneFilled;
    case 'microphoneOutline':
      return MicrophoneOutline;
    case 'minimize':
      return Minimize;
    case 'minus':
      return Minus;
    case 'minusCircle':
      return MinusCircle;
    case 'minusSquare':
      return MinusSquare;
    case 'module':
      return Module;
    case 'monitorCheck':
      return MonitorCheck;
    case 'monitorPlay':
      return MonitorPlay;
    case 'monitorSmartphone':
      return MonitorSmartphone;
    case 'moreHorizontal':
      return MoreHorizontal;
    case 'mouse':
      return Mouse;
    case 'mousePointer':
      return MousePointer;
    case 'mousePointerClick':
      return MousePointerClick;
    case 'move':
      return Move;
    case 'moveDiagonalL2R':
      return MoveDiagonalL2R;
    case 'moveDiagonalR2L':
      return MoveDiagonalR2L;
    case 'moveDown':
      return MoveDown;
    case 'moveDownLeft':
      return MoveDownLeft;
    case 'moveDownRight':
      return MoveDownRight;
    case 'moveHorizontal':
      return MoveHorizontal;
    case 'moveLeft':
      return MoveLeft;
    case 'moveRight':
      return MoveRight;
    case 'moveUp':
      return MoveUp;
    case 'moveUpLeft':
      return MoveUpLeft;
    case 'moveUpRight':
      return MoveUpRight;
    case 'moveVertical':
      return MoveVertical;
    case 'mugFilled':
      return MugFilled;
    case 'mugOutline':
      return MugOutline;
    case 'multipleUsersFilled':
      return MultipleUsersFilled;
    case 'multipleUsersOutline':
      return MultipleUsersOutline;
    case 'needleFilled':
      return NeedleFilled;
    case 'needleOutline':
      return NeedleOutline;
    case 'nurse':
      return Nurse;
    case 'nurseView':
      return NurseView;
    case 'o2Filled':
      return O2Filled;
    case 'openDoor':
      return OpenDoor;
    case 'packageCheck':
      return PackageCheck;
    case 'packageOpen':
      return PackageOpen;
    case 'packageSearch':
      return PackageSearch;
    case 'partyPopper':
      return PartyPopper;
    case 'pause':
      return Pause;
    case 'pauseCircle':
      return PauseCircle;
    case 'pauseFilled':
      return PauseFilled;
    case 'pen':
      return Pen;
    case 'penFilled':
      return PenFilled;
    case 'penOutline':
      return PenOutline;
    case 'penSquare':
      return PenSquare;
    case 'penTool':
      return PenTool;
    case 'penToolFilled':
      return PenToolFilled;
    case 'pencilLine':
      return PencilLine;
    case 'pencilRuler':
      return PencilRuler;
    case 'percent':
      return Percent;
    case 'petFilled':
      return PetFilled;
    case 'petOutline':
      return PetOutline;
    case 'phoneCall':
      return PhoneCall;
    case 'phoneFilled':
      return PhoneFilled;
    case 'phoneForwarded':
      return PhoneForwarded;
    case 'phoneIncoming':
      return PhoneIncoming;
    case 'phoneMissed':
      return PhoneMissed;
    case 'phoneOff':
      return PhoneOff;
    case 'phoneOutgoing':
      return PhoneOutgoing;
    case 'phoneOutline':
      return PhoneOutline;
    case 'pillFilled':
      return PillFilled;
    case 'pillOutline':
      return PillOutline;
    case 'pin':
      return Pin;
    case 'pinOff':
      return PinOff;
    case 'pipeFilled':
      return PipeFilled;
    case 'pipeOutline':
      return PipeOutline;
    case 'playCircle':
      return PlayCircle;
    case 'playFilled':
      return PlayFilled;
    case 'playOutline':
      return PlayOutline;
    case 'playSquare':
      return PlaySquare;
    case 'plus':
      return Plus;
    case 'plusCircle':
      return PlusCircle;
    case 'plusSquare':
      return PlusSquare;
    case 'pointer':
      return Pointer;
    case 'pollFilled':
      return PollFilled;
    case 'pollOutline':
      return PollOutline;
    case 'pound':
      return Pound;
    case 'presentationFilled':
      return PresentationFilled;
    case 'presentationOutline':
      return PresentationOutline;
    case 'printerFilled':
      return PrinterFilled;
    case 'printerOutline':
      return PrinterOutline;
    case 'qrCode':
      return QrCode;
    case 'questionMarkFilled':
      return QuestionMarkFilled;
    case 'questionMarkOutline':
      return QuestionMarkOutline;
    case 'quote':
      return Quote;
    case 'quoteLeft':
      return QuoteLeft;
    case 'quoteRight':
      return QuoteRight;
    case 'redo':
      return Redo;
    case 'refreshCcw':
      return RefreshCcw;
    case 'refreshCcwDot':
      return RefreshCcwDot;
    case 'refreshCwOff':
      return RefreshCwOff;
    case 'roadFilled':
      return RoadFilled;
    case 'roadOutline':
      return RoadOutline;
    case 'rocket':
      return Rocket;
    case 'rotateCcw':
      return RotateCcw;
    case 'rotateCw':
      return RotateCw;
    case 'rulerFilled':
      return RulerFilled;
    case 'rulerOutline':
      return RulerOutline;
    case 'save':
      return Save;
    case 'saveAll':
      return SaveAll;
    case 'saveFilled':
      return SaveFilled;
    case 'scale':
      return Scale;
    case 'scale3d':
      return Scale3d;
    case 'scan':
      return Scan;
    case 'scanFace':
      return ScanFace;
    case 'scanLine':
      return ScanLine;
    case 'scrollText':
      return ScrollText;
    case 'searchCheck':
      return SearchCheck;
    case 'searchCode':
      return SearchCode;
    case 'searchSlash':
      return SearchSlash;
    case 'searchX':
      return SearchX;
    case 'send':
      return Send;
    case 'sendHorizonal':
      return SendHorizonal;
    case 'share':
      return Share;
    case 'shareFilled':
      return ShareFilled;
    case 'shareOutline':
      return ShareOutline;
    case 'shieldAlert':
      return ShieldAlert;
    case 'shieldCheck':
      return ShieldCheck;
    case 'shieldFilled':
      return ShieldFilled;
    case 'shieldOutline':
      return ShieldOutline;
    case 'shieldTickOutline':
      return ShieldTickOutline;
    case 'shirt':
      return Shirt;
    case 'shoppingBag':
      return ShoppingBag;
    case 'shoppingCart':
      return ShoppingCart;
    case 'shrink':
      return Shrink;
    case 'shuffle':
      return Shuffle;
    case 'signLanguage':
      return SignLanguage;
    case 'signOut':
      return SignOut;
    case 'skipBack':
      return SkipBack;
    case 'skipForward':
      return SkipForward;
    case 'slack':
      return Slack;
    case 'smartphone':
      return Smartphone;
    case 'smartphoneCharging':
      return SmartphoneCharging;
    case 'smartphoneNfc':
      return SmartphoneNfc;
    case 'smile':
      return Smile;
    case 'smilePlus':
      return SmilePlus;
    case 'sort':
      return Sort;
    case 'sparkle':
      return Sparkle;
    case 'sparkles':
      return Sparkles;
    case 'spellCheck':
      return SpellCheck;
    case 'spellCheckHighlight':
      return SpellCheckHighlight;
    case 'split':
      return Split;
    case 'starFilled':
      return StarFilled;
    case 'starHalf':
      return StarHalf;
    case 'starOff':
      return StarOff;
    case 'starOutline':
      return StarOutline;
    case 'stethoscopeFilled':
      return StethoscopeFilled;
    case 'stethoscopeOutline':
      return StethoscopeOutline;
    case 'stopFilled':
      return StopFilled;
    case 'stopOutline':
      return StopOutline;
    case 'strikethrough':
      return Strikethrough;
    case 'switchCamera':
      return SwitchCamera;
    case 'sync':
      return Sync;
    case 'tag':
      return Tag;
    case 'tags':
      return Tags;
    case 'textCursor':
      return TextCursor;
    case 'textCursorInput':
      return TextCursorInput;
    case 'textQuote':
      return TextQuote;
    case 'textSelect':
      return TextSelect;
    case 'thermometerFilled':
      return ThermometerFilled;
    case 'thermometerOutline':
      return ThermometerOutline;
    case 'thumbsDown':
      return ThumbsDown;
    case 'thumbsUp':
      return ThumbsUp;
    case 'timerFilled':
      return TimerFilled;
    case 'timerOff':
      return TimerOff;
    case 'timerOutline':
      return TimerOutline;
    case 'timerReset':
      return TimerReset;
    case 'timesDefault':
      return TimesDefault;
    case 'timesFilled':
      return TimesFilled;
    case 'timesOutline':
      return TimesOutline;
    case 'trash':
      return Trash;
    case 'trashFilled':
      return TrashFilled;
    case 'trashOutline':
      return TrashOutline;
    case 'treeDeciduous':
      return TreeDeciduous;
    case 'treePine':
      return TreePine;
    case 'trees':
      return Trees;
    case 'trendingDown':
      return TrendingDown;
    case 'trendingUp':
      return TrendingUp;
    case 'twitter':
      return Twitter;
    case 'underline':
      return Underline;
    case 'undo':
      return Undo;
    case 'unfoldHorizontal':
      return UnfoldHorizontal;
    case 'unfoldVertical':
      return UnfoldVertical;
    case 'universalAccess':
      return UniversalAccess;
    case 'unlink':
      return Unlink;
    case 'unlinkAlt':
      return UnlinkAlt;
    case 'upload':
      return Upload;
    case 'uploadCloud':
      return UploadCloud;
    case 'user':
      return User;
    case 'userBan':
      return UserBan;
    case 'userCard':
      return UserCard;
    case 'userCheck':
      return UserCheck;
    case 'userCircle':
      return UserCircle;
    case 'userCog':
      return UserCog;
    case 'userFilled':
      return UserFilled;
    case 'userMinus':
      return UserMinus;
    case 'userPlus':
      return UserPlus;
    case 'userReturn':
      return UserReturn;
    case 'userSquare':
      return UserSquare;
    case 'userTimes':
      return UserTimes;
    case 'videoFilled':
      return VideoFilled;
    case 'videoOutline':
      return VideoOutline;
    case 'voicemail':
      return Voicemail;
    case 'volumeMax':
      return VolumeMax;
    case 'volumeMaxFilled':
      return VolumeMaxFilled;
    case 'volumeMute':
      return VolumeMute;
    case 'volumeMuteFilled':
      return VolumeMuteFilled;
    case 'volumeNone':
      return VolumeNone;
    case 'volumeOn':
      return VolumeOn;
    case 'walker':
      return Walker;
    case 'wallet':
      return Wallet;
    case 'walletCards':
      return WalletCards;
    case 'wheelchair':
      return Wheelchair;
    case 'wifi':
      return Wifi;
    case 'wifiOff':
      return WifiOff;
    case 'wrapText':
      return WrapText;
    case 'wrench':
      return Wrench;
    case 'xOctagon':
      return XOctagon;
    case 'xSquare':
      return XSquare;
    case 'xp':
      return Xp;
    case 'youtube':
      return Youtube;
    case 'zap':
      return Zap;
    case 'zapOff':
      return ZapOff;
    case 'zoomMinusFilled':
      return ZoomMinusFilled;
    case 'zoomMinusOutline':
      return ZoomMinusOutline;
    case 'zoomOutline':
      return ZoomOutline;
    case 'zoomPlusFilled':
      return ZoomPlusFilled;
    case 'zoomPlusOutline':
      return ZoomPlusOutline;
  }
}

export const Icon: FunctionComponent<IconType> = ({
  icon,
  fill,
  ...iconProps
}) => {
  const Icon = getIconSvg(icon);

  return (
    <Icon className={styles.iwIcon} style={{ fill: fill }} {...iconProps} />
  );
};
